<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">
        <app-i18n code="home.menu"></app-i18n>
      </el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/game' }">
        <app-i18n code="entities.game.menu"></app-i18n>
      </el-breadcrumb-item>
      <el-breadcrumb-item>
        <app-i18n code="entities.game.view.title"></app-i18n>
      </el-breadcrumb-item>
    </el-breadcrumb>

    <div class="app-content-page">
      <h1 class="app-content-title app-content-title--hidden">
        <app-i18n code="entities.game.view.title"></app-i18n>
      </h1>

      <div class="app-page-spinner" v-if="loading" v-loading="loading"></div>

      <app-game-view-toolbar v-if="record"></app-game-view-toolbar>

      <el-form
        :label-position="labelPosition"
        :label-width="labelWidthForm"
        @submit.prevent.native
        class="form"
        v-if="record"
      >
        <app-view-item-text :label="fields.id.label" :value="presenter(record, 'id')"></app-view-item-text>

        <app-view-item-relation-to-one
          :label="fields.awayTeam.label"
          :permission="fields.awayTeam.readPermission"
          :url="fields.awayTeam.viewUrl"
          :value="presenter(record, 'awayTeam')"
        ></app-view-item-relation-to-one>

        <app-view-item-relation-to-one
          :label="fields.localTeam.label"
          :permission="fields.localTeam.readPermission"
          :url="fields.localTeam.viewUrl"
          :value="presenter(record, 'localTeam')"
        ></app-view-item-relation-to-one>

        <app-view-item-text :label="fields.date.label" :value="presenter(record, 'date')"></app-view-item-text>

        <app-view-item-text :label="fields.hour.label" :value="presenter(record, 'hour')"></app-view-item-text>

        <app-view-item-text :label="fields.duration.label" :value="presenter(record, 'duration')"></app-view-item-text>

        <app-view-item-text :label="fields.location.label" :value="presenter(record, 'location')"></app-view-item-text>

        <app-view-item-text :label="fields.status.label" :value="presenter(record, 'status')"></app-view-item-text>

        <app-view-item-text :label="fields.createdAt.label" :value="presenter(record, 'createdAt')"></app-view-item-text>

        <app-view-item-text :label="fields.updatedAt.label" :value="presenter(record, 'updatedAt')"></app-view-item-text>
      </el-form>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import GameViewToolbar from '@modules/game/components/game-view-toolbar.vue';
import { GameModel } from '@modules/game/game-model';

export default {
  name: 'app-game-view-page',

  props: ['id'],

  components: {
    [GameViewToolbar.name]: GameViewToolbar,
  },

  computed: {
    ...mapGetters({
      labelPosition: 'layout/labelPosition',
      labelWidthForm: 'layout/labelWidthForm',
      record: 'game/view/record',
      loading: 'game/view/loading',
      dateFormat: 'auth/manage/dateFormat',
      timeFormat: 'auth/manage/timeFormat',
    }),
  },

  async created() {
    await this.doFind(this.id);
  },

  methods: {
    ...mapActions({
      doFind: 'game/view/doFind',
    }),

    presenter(record, fieldName) {
      const { dateFormat, timeFormat } = this;
      return new GameModel({ dateFormat, timeFormat }).presenter(record, fieldName);
    },
  }
};
</script>
